module.exports = __webpack_public_path__ + "static/media/38.27d888db.mp3";